import { Icon } from "./Icon.tsx";

/** "Add Pump" tool icon — AddConduitIcon.tsx's own two-nodes-joined-by-a-pipe glyph, with a small upward chevron at the midpoint (lift) marking it as a pump rather than a plain conduit. */
export function AddPumpIcon() {
  return (
    <Icon>
      <circle cx="5" cy="19" r="2.5" />
      <circle cx="19" cy="5" r="2.5" />
      <path d="M7 17.5L17 6.5" />
      <path d="M9.5 13.5l2-2 2 2" />
    </Icon>
  );
}
